module.exports = __webpack_public_path__ + "static/media/wallet.3e34c1d5.svg";